
// import iconNavActWallet from "../../../Icons/nav-icons/active/wallet.png";
// import iconNavWallet from "../../../Icons/nav-icons/none-active/wallet.png";



// import iconNavActHome from "../../../Icons/NV/nav-version 2.0/act/home.png";
// import iconNavActSaved from "../../../Icons/NV/nav-version 2.0/act/noti.png";
// import iconNavActBusiness from "../../../Icons/NV/nav-version 2.0/act/acti.png";
// import iconNavActMenu from "../../../Icons/NV/nav-version 2.0/act/menu.png";

// import iconNavHome from "../../../Icons/NV/nav-version 2.0/none-act/home.png";
// import iconNavSaved from "../../../Icons/NV/nav-version 2.0/none-act/noti.png";
// import iconNavBusiness from "../../../Icons/NV/nav-version 2.0/none-act/acti.png";
// import iconNavMenu from "../../../Icons/NV/nav-version 2.0/none-act/menu.png";





import iconNavActHome from "../../../Icons/NV/nav-nv/act/home.png";
import iconNavActSaved from "../../../Icons/NV/nav-nv/act/notification.png";
import iconNavActBusiness from "../../../Icons/NV/nav-nv/act/acti.png";
import iconNavActMenu from "../../../Icons/NV/nav-nv/act/menu.png";

import iconNavHome from "../../../Icons/NV/nav-nv/n-act/home.png";
import iconNavSaved from "../../../Icons/NV/nav-nv/n-act/notification.png";
import iconNavBusiness from "../../../Icons/NV/nav-nv/n-act/acti.png";
import iconNavMenu from "../../../Icons/NV/nav-nv/n-act/menu.png";







import homeScreen from "./home-screen";
import BusinessOwn from "../business-page-own-veiw/busine-own";

// import BusinessPageEditor from "../business-page-editor/business-page-editor";

import Menu from "../main-menu/menu";
import { doc } from "firebase/firestore";
import firebase from "../firebase";
import saved from "../saved-and-Followed/saved";

class Nav {
  #navWas = "Home";
  #navIs = "Home";

  #keepHidden = false;
  constructor() {
    this.icons = {
      Home: { active: iconNavActHome, inactive: iconNavHome },
      Notification: { active: iconNavActSaved, inactive: iconNavSaved },
      // Wallet: { active: iconNavActWallet, inactive: iconNavWallet },
      Activity: { active: iconNavActBusiness, inactive: iconNavBusiness },
      Menu: { active: iconNavActMenu, inactive: iconNavMenu },
    };
  }

  _changeNav(InNav) {

    if (InNav === "Menu") return

    const navTaps = document.querySelectorAll(".NavBarCon2");
    let menuOption = InNav;

    if (InNav === "last") {
      menuOption = this.#navWas;
    }
    navTaps.forEach((navTap) => {
      const navIcon = navTap.querySelector(".NavBarIconCon");
      const NavActiveBar = navTap.querySelector(".NavBarCon2D");

      const NavActiveBarText = navTap.querySelector(".NavBarText");

      if (navIcon && NavActiveBar) {

        // console.log('here', navTap);
        if (navTap.dataset.menuoption === menuOption) {
          // console.log('here', navTap);
          navTap.classList.add("NavBarCon2DAct");
          NavActiveBarText.classList.add("NavBarTextAct");
          navIcon.src = this.icons[menuOption].active;
        } else {
          navIcon.src = this.icons[navTap.dataset.menuoption].inactive;
          navTap.classList.remove("NavBarCon2DAct");
          NavActiveBarText.classList.remove("NavBarTextAct");
        }
      }
    });
  }

  _blockNav(block) {
    const HeaderCon1BolckAction = document.getElementById(
      "HeaderCon1BolckAction"
    );
    const NavBarCon1BlockNav = document.getElementById("NavBarCon1BlockNav");
    if (block) {
      HeaderCon1BolckAction.style.display = "flex";
      NavBarCon1BlockNav.style.display = "flex";
    } else {
      HeaderCon1BolckAction.style.display = "none";
      NavBarCon1BlockNav.style.display = "none";
    }
  }
  _init(NavIn = 'Home', tab = 'businesses') {
    const navBar = document.getElementById("NavBarCon1");
    // const ButtonReward = document.getElementById("ButtonReward");



    // ButtonReward.addEventListener("click", () => {
    //   alert('Estamos desarollando un sistema para que tu podrás generar ingresos extras con Mercado MAI. Si ya estás esperando esto, porfavor mandanos un WhtasApp al: +52 981 107 2143, para decirnos tus sugerencias.')
    // })
    navBar.addEventListener("click", (e) => {

      const closestNavOption = e.target.closest('.NavBarCon2')
      if (!closestNavOption) return

      const navOption = closestNavOption.dataset.menuoption

      this._changeNav(navOption);


      if (this.#navIs !== "Menu") {
        this.#navWas = this.#navIs;
      }
      this.#navIs = navOption;

      if (navOption === "Menu") {
        Menu._setMenu();
      }
      if (navOption === "Home") {
        homeScreen._init();
      }
      if (navOption === "Activity") {
        BusinessOwn._init(tab);
      }
      if (navOption === "Wallet") {
        // wallet._open();
        console.log("wallet now");
      }
      if (navOption === "Notification") {
        saved._openNotifications();
      }
    });

    this._changeNav(NavIn);
  }



  _initNavObserver() {

    function translateElementY(id, yPx) {

      const el = document.getElementById(id);

      if (!el) {
        console.warn(`Element not found: ${id}`);
        return;
      }

      el.style.transform = `translateY(${yPx}px)`;
    }


    const action = (isGreater, width) => {

      const navButtonPublishCon1B = document.getElementById("navButtonPublishCon1B");
      const navButtonPublishCon1 = document.getElementById("navButtonPublishCon1");
      const btnScrollTop = document.getElementById("homeScreenDisplayInitialScreenScrollButtonScrollTop");

      console.log('Width:', width);

      if (isGreater) {
        console.log('Element is larger than 500px');
        navButtonPublishCon1B.style.display = "none";
        navButtonPublishCon1.style.display = "flex";
        btnScrollTop.classList.remove('initScreenButtonScrollTopCon1Bottom180')
      } else {
        console.log('Element is smaller than 500px');
        navButtonPublishCon1B.style.display = "flex";
        navButtonPublishCon1.style.display = "none";
        btnScrollTop.classList.add('initScreenButtonScrollTopCon1Bottom180')
      }

    }



    function watchElementWidth(id, minWidth) {

      const el = document.getElementById(id);

      if (!el) {
        console.warn(`Element not found: ${id}`);
        return;
      }

      // Initial check
      action(el.offsetWidth > minWidth, el.offsetWidth);

      // Live resize observer
      const observer = new ResizeObserver((entries) => {

        for (const entry of entries) {

          const width = entry.contentRect.width;

          action(width > minWidth, width);
        }
      });

      observer.observe(el);

      // Optional cleanup return
      return () => observer.disconnect();
    }


    watchElementWidth('NavBarCon1', 360);
  }

  _hide(keepHidden = false) {

    if (keepHidden) {
      this.#keepHidden = true;
    }
    const NavBarCon1 = document.getElementById("NavBarCon1");
    // NavBarCon1.style.display = "none";
    NavBarCon1.classList.add("homeHeaderSearchCon1disapearNav");
  }
  _show(keepHidden = true) {
    if (!keepHidden) {
      this.#keepHidden = false;
    }
    if (this.#keepHidden) return
    const NavBarCon1 = document.getElementById("NavBarCon1");
    NavBarCon1.classList.remove("homeHeaderSearchCon1disapearNav");
    // NavBarCon1.style.display = "flex";
  }
}

export default new Nav();
